module.exports = __webpack_public_path__ + "static/media/intl-welcome-bg.01bb2af5.jpg";